export enum TipoProgramaFidelidade {
  CASHBACK = "CASHBACK",
  ITENS = "ITENS"
}

export const TipoProgramaFidelidadeDescricao: Record<TipoProgramaFidelidade, string> = {
  [TipoProgramaFidelidade.CASHBACK]: "Cashback",
  [TipoProgramaFidelidade.ITENS]: "Itens"
}

